import { SVGProps } from 'react'

export const Copy = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      fill="currentColor"
      d="M13.75.833h-10c-.917 0-1.667.75-1.667 1.667v11.666H3.75V2.5h10V.833zm2.5 3.333H7.083c-.917 0-1.667.75-1.667 1.667V17.5c0 .916.75 1.666 1.667 1.666h9.167c.916 0 1.666-.75 1.666-1.666V5.833c0-.917-.75-1.667-1.666-1.667zm0 13.334H7.083V5.833h9.167V17.5z"
    ></path>
  </svg>
)
